import { trendingBriefs } from '@/mocks/gossipContent';

const TICKER = [
  '沈棠片场缺席录音持续发酵，导演组被喊话回应',
  'PrismX 旧帖考古单日新增 8 万讨论',
  '大嘴哥哥年货专场被点名关注',
  '北岸少年解散旧料重上热榜',
  '轻盏茶联名文案翻车后删除致歉',
];

export default function Hero() {
  const top3 = trendingBriefs.slice(0, 3);

  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950 text-background-50">
      {/* 背景视觉（陪衬，文案为主） */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20dark%20editorial%20magazine%20backdrop%20bathed%20in%20deep%20crimson%20red%20and%20black%20gradient%20light%20with%20soft%20drifting%20smoke%20and%20gentle%20lens%20glow%2C%20dramatic%20high%20contrast%20cinematic%20atmosphere%20with%20subtle%20film%20grain%2C%20empty%20dramatic%20corner%20of%20a%20grand%20stage%2C%20no%20people%2C%20rich%20layered%20textures%2C%20mysterious%20artistic%20magazine%20cover&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt="红黑料 每日吃瓜刊封面背景"
          className="absolute inset-0 h-full w-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/92 to-foreground-950/70"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 md:px-6 pt-10 md:pt-16 pb-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          {/* 文案主区 */}
          <div className="lg:col-span-7 animate-rise">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 text-foreground-950 px-3 py-1 text-xs font-medium">
                <i className="ri-sparkling-2-line w-4 h-4 flex items-center justify-center" />
                封面报道 · 片场录音流出
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200/30 px-3 py-1 text-xs text-background-200">
                <i className="ri-verified-badge-line w-4 h-4 flex items-center justify-center" />
                证据链 3 段音频
              </span>
            </div>

            <h2 className="font-heading text-4xl md:text-6xl font-bold leading-[1.12] mt-5 tracking-tight">
              一场九分钟的等待，
              <br />
              <span className="text-primary-500">让整个剧组买单</span>
            </h2>

            <p className="mt-5 max-w-xl text-background-200/90 leading-relaxed text-[15px] md:text-base">
              三段共九分钟的片场录音，指向某剧组主演多次中途离场。我们把录音时间线、群演侧写与通告单逐段对齐，只为还原——
              那些在补光灯熄灭之后，依旧亮着的加班费与未说出口的回应。
            </p>

            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="#featured"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-medium hover:bg-primary-600 transition-colors"
              >
                查看封面大瓜
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="#crash"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 px-5 py-2.5 text-sm text-background-50 hover:bg-background-100/10 transition-colors"
              >
                翻车现场实录
              </a>
            </div>

            <div className="mt-7 flex items-center gap-4 text-xs text-background-300/80">
              <span>红黑料 · 资料组</span>
              <span className="hidden sm:inline text-background-300/40">|</span>
              <span>首发于 09:20</span>
              <span className="hidden sm:inline text-background-300/40">|</span>
              <span>已按引用源归档</span>
            </div>
          </div>

          {/* 右侧：本日速读 */}
          <div className="lg:col-span-5">
            <div className="rounded-lg bg-background-50/95 text-foreground-950 p-5 md:p-6 animate-rise" style={{ animationDelay: '120ms' }}>
              <div className="flex items-center justify-between border-b border-background-200/80 pb-3">
                <h3 className="font-heading text-lg font-bold">本日速读 · 热度前三</h3>
                <span className="inline-flex items-center gap-1.5 text-xs text-primary-600">
                  <i className="ri-fire-fill w-4 h-4 flex items-center justify-center pulse-dot" />
                  实时
                </span>
              </div>

              <div className="mt-4 space-y-4">
                {top3.map((it) => (
                  <a key={it.id} href="#trending" className="group block">
                    <div className="flex gap-3">
                      <span
                        className={`font-heading text-2xl font-bold leading-none shrink-0 ${
                          it.rank === 1 ? 'text-primary-600' : it.rank === 2 ? 'text-accent-600' : 'text-secondary-400'
                        }`}
                      >
                        {String(it.rank).padStart(2, '0')}
                      </span>
                      <div className="min-w-0">
                        <h4 className="font-heading text-[15px] font-semibold leading-snug group-hover:text-primary-700 transition-colors">
                          {it.title}
                        </h4>
                        <p className="mt-1 text-xs text-foreground-600 line-clamp-2">{it.summary}</p>
                      </div>
                    </div>
                    {it.rank < 3 && <div className="mt-4 border-t border-dashed border-background-200/90" />}
                  </a>
                ))}
              </div>

              <a
                href="#trending"
                className="mt-5 flex items-center justify-center gap-2 rounded-md bg-background-100 px-4 py-2.5 text-sm text-foreground-800 hover:bg-background-200 transition-colors"
              >
                看完整热榜 Top10
                <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>
        </div>

        {/* 滚动速报条 */}
        <div className="mt-8 rounded-md border border-background-200/20 bg-background-50/10 overflow-hidden">
          <div className="flex items-stretch">
            <div className="hidden sm:flex items-center gap-2 shrink-0 px-3.5 bg-accent-500 text-foreground-950 text-xs font-medium">
              <i className="ri-pulse-line w-4 h-4 flex items-center justify-center pulse-dot" />
              实时速报
            </div>
            <div className="relative flex-1 overflow-hidden py-2.5">
              <div className="flex w-max animate-marquee gap-10 pr-10">
                {[...TICKER, ...TICKER].map((t, i) => (
                  <span key={i} className="whitespace-nowrap text-xs text-background-200/90 flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-primary-500 w-4 h-4 flex items-center justify-center" />
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}